module.exports = __webpack_public_path__ + "static/media/Whitepaper.83675e89.pdf";